// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-f809d894] {\n  box-sizing: border-box;\n}\n.div-top[data-v-f809d894] {\n  margin-bottom: 10px;\n  height: 40px;\n}\n.div-center[data-v-f809d894] {\n  margin-top: 10px;\n  height: calc(100% - 90px);\n}", ""]);
// Exports
module.exports = exports;
